module.exports = __webpack_public_path__ + "assets/btnMy.b43f279e.png";